
declare var Object: any;
export interface FuelRefillViewInterface {
  "id": number;
  "userId": number;
  "employeeId": number;
  "vehicleId": number;
  "requestID": string;
  "dateTime": Date;
  "date"?: Date;
  "vdate"?: any;
  "amount": number;
  "odometer": number;
  "fuelType": string;
  "cardNum": string;
  "receiptImgFileId": string;
  "meta": any;
  "note"?: string;
  "ctime": Date;
  "utime": Date;
  "dtime"?: Date;
  "dtime_str"?: string;
  "facility_shortname"?: string;
  "employee_tenantId"?: number;
  "employee_status"?: string;
  "employee_person_lastname"?: string;
  "employee_person_firstname"?: string;
  "employee_person_fullname"?: string;
  "vehicle_internalId"?: number;
}

export class FuelRefillView implements FuelRefillViewInterface {
  "id": number;
  "userId": number;
  "employeeId": number;
  "vehicleId": number;
  "requestID": string;
  "dateTime": Date;
  "date": Date;
  "vdate": any;
  "amount": number;
  "odometer": number;
  "fuelType": string;
  "cardNum": string;
  "receiptImgFileId": string;
  "meta": any;
  "note": string;
  "ctime": Date;
  "utime": Date;
  "dtime": Date;
  "dtime_str": string;
  "facility_shortname": string;
  "employee_tenantId": number;
  "employee_status": string;
  "employee_person_lastname": string;
  "employee_person_firstname": string;
  "employee_person_fullname": string;
  "vehicle_internalId": number;
  constructor(data?: FuelRefillViewInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `FuelRefillView`.
   */
  public static getModelName() {
    return "FuelRefillView";
  }

  /**
  * This method creates an instance of FuelRefillView for dynamic purposes.
  **/
  public static factory(data: FuelRefillViewInterface): FuelRefillView{
    return new FuelRefillView(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FuelRefillView',
      plural: 'FuelRefillViews',
      path: 'FuelRefillViews',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "employeeId": {
          name: 'employeeId',
          type: 'number'
        },
        "vehicleId": {
          name: 'vehicleId',
          type: 'number'
        },
        "requestID": {
          name: 'requestID',
          type: 'string'
        },
        "dateTime": {
          name: 'dateTime',
          type: 'Date'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "vdate": {
          name: 'vdate',
          type: 'any'
        },
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "odometer": {
          name: 'odometer',
          type: 'number'
        },
        "fuelType": {
          name: 'fuelType',
          type: 'string'
        },
        "cardNum": {
          name: 'cardNum',
          type: 'string'
        },
        "receiptImgFileId": {
          name: 'receiptImgFileId',
          type: 'string'
        },
        "meta": {
          name: 'meta',
          type: 'any'
        },
        "note": {
          name: 'note',
          type: 'string'
        },
        "ctime": {
          name: 'ctime',
          type: 'Date'
        },
        "utime": {
          name: 'utime',
          type: 'Date'
        },
        "dtime": {
          name: 'dtime',
          type: 'Date'
        },
        "dtime_str": {
          name: 'dtime_str',
          type: 'string'
        },
        "facility_shortname": {
          name: 'facility_shortname',
          type: 'string'
        },
        "employee_tenantId": {
          name: 'employee_tenantId',
          type: 'number'
        },
        "employee_status": {
          name: 'employee_status',
          type: 'string'
        },
        "employee_person_lastname": {
          name: 'employee_person_lastname',
          type: 'string'
        },
        "employee_person_firstname": {
          name: 'employee_person_firstname',
          type: 'string'
        },
        "employee_person_fullname": {
          name: 'employee_person_fullname',
          type: 'string'
        },
        "vehicle_internalId": {
          name: 'vehicle_internalId',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
